<template>
  <div>
    <div class="display-flex justify-space-between align-center mb-3">
      <div class="display-flex gap-8 align-center">
        <div class="cart__title">Cart</div>
        <div class="cart__count text-center">4</div>
      </div>
      <div class="text-right" @click="$router.push({ name: 'YouMobile' })">
        <img
          src="../../assets/mobile/icon/arrow-down.svg"
          width="20"
          height="20"
        />
      </div>
    </div>

    <div v-for="i in 3" :key="i">
      <div class="display-flex gap-15">
        <img src="../../assets/mobile/cart.png" width="96" height="96" />
        <div>
          <div class="text-capitalize text-dmsans-14">
            The Slow Rush with exclusive featuring the thing
          </div>
          <div class="text-dmsans-14 text-grey-1 font-weight-700 my-1">
            Tame Impala
          </div>
          <div class="text-inter-12">Other</div>
        </div>
      </div>

      <div class="display-flex justify-space-between align-center mt-2">
        <div class="display-flex align-center gap-15">
          <div class="display-flex align-center cart__item__count">
            <span>
              <img
                src="../../assets/mobile/icon/sub.svg"
                width="8"
                height="8"
              />
            </span>
            <span>1</span>
            <span>
              <img
                src="../../assets/mobile/icon/plus.svg"
                width="8"
                height="8"
              />
            </span>
          </div>
          <div>$129.99</div>
        </div>
        <div class="text-right">
          <img
            src="../../assets/mobile/icon/trash.svg"
            width="32"
            height="30"
          />
        </div>
      </div>
      <hr class="my-3" />
    </div>

    <v-btn
      class="text-poppins-14 text-white font-weight-700 btn-checkout ma-0"
      @click="$router.push('checkoutm')"
    >
      CHECKOUT
    </v-btn>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.cart {
  &__title {
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: capitalize;
  }
  &__count {
    border-radius: 3px;
    background: #ff2424;
    width: 31px;
    height: 21px;
    color: #fff;
    font-family: Poppins;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -0.13px;
  }

  &__item {
    &__count {
      max-width: 96px;
      height: 32px;
      flex-shrink: 0;
      background: #f5f5f5;
      display: flex;
      justify-content: space-evenly;
    }
  }
}

.btn-checkout {
  border-radius: 100px;
  background: #000 !important;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// cart.vue?732c924a